/*
  Everything in Stage 2 is related to setting up the React appplication.

  We want to get a First Contentful Paint as fast as possible.
 */

import { createElement } from 'react';
import { render } from 'react-dom';

// Initialize global stores ASAP
import '/global-state/init';

import { MainApp } from '../app';
import { getSentry } from '../module/sentry';

// Import global styles
import '../scss/globals.scss';

// Initialize Sentry asap
getSentry();

// Wait for WUI to load before rendering
render(createElement(MainApp), document.getElementById('jw-dash-root'), () => {
  // Wait for React app to render before triggering stage-3
  import('./stage-3').then(() => {
    // no-op
  });
});

// eslint-disable-next-line import/no-default-export
export default {};
